import { contract } from "@cleanbudget/contract";
import { createORPCClient } from "@orpc/client";
import type { ContractRouterClient } from "@orpc/contract";
import type { JsonifiedClient } from "@orpc/openapi-client";
import { OpenAPILink } from "@orpc/openapi-client/fetch";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";

/**
 * The API client, typed by the contract. The API is on the same origin under `/api` (one Worker
 * serves both), in dev too: the Vite plugin runs the Worker behind the dev server.
 */
const link = new OpenAPILink(contract, {
	url: () => `${window.location.origin}/api`,
});

/** For calls outside React's data flow. In components and loaders use `orpc`. */
export const client: JsonifiedClient<ContractRouterClient<typeof contract>> = createORPCClient(link);

/**
 * TanStack Query options for every procedure: `orpc.health.check.queryOptions()` in a loader's
 * `ensureQueryData` and in the component's `useSuspenseQuery`, `.mutationOptions()` for writes.
 */
export const orpc = createTanstackQueryUtils(client);
